import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ConfirmationDialogComponent } from 'src/app/components/shared-components/confirmation-dialog/confirmation-dialog.component';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { FakeDollarVarsPipe } from 'src/app/pipes/fake-dollar-vars-pipe/fake-dollar-vars.pipe';
import { TicketsService } from 'src/app/services/tickets-service/tickets.service';
import { TicketsTicketPreviewDialogComponent } from '../tickets-ticket-preview-dialog/tickets-ticket-preview-dialog.component';

@Component({
  selector: 'app-tickets-ticket-resume-card',
  templateUrl: './tickets-ticket-resume-card.component.html',
  styleUrls: ['./tickets-ticket-resume-card.component.scss']
})
export class TicketsTicketResumeCardComponent implements OnInit, OnDestroy {

  @Input() ticket;
  @Input() viewDisposition;
  updateTicketStatusSubscription: Subscription;
  deleteTicketSubscription: Subscription;
  previewZplTicketSubscription: Subscription;

  constructor(private ticketsService: TicketsService,
              private snackbarService: SnackBarService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              public dialog: MatDialog) { }

  ngOnInit() { }

  public toggleStatus() {
    this.updateTicketStatusSubscription = this.ticketsService.updateTicketStatus(this.ticket.InternalId, !this.ticket.Active).subscribe(
      (res) => {
        this.ticket.Active = !this.ticket.Active;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public gotoDetails(e) {
    if ((e.target.className !== 'mat-icon notranslate material-icons mat-icon-no-color') && (e.target.className !== 'mat-icon-button') && (e.target.tagName !== 'SPAN')) {
      this.router.navigate(['../ticket', this.ticket.InternalId], { relativeTo: this.activatedRoute.parent });
    }
  }

  public deleteTicket() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'important',
        messages: ['tickets-page.delete ticket', 'delete anyway']
      }
    });

    dialogRef.afterClosed().subscribe(action => {
      if (action) {
        this.deleteTicketSubscription = this.ticketsService.deleteTicket(this.ticket.InternalId).subscribe(
          (res) => {
            this.ticketsService.refreshTickets();
          },
          (error) => {
            this.snackbarService.open(error['error']['message'], 'error');
          }
        );
      }
    });
  }

  public previewHtmlTicket() {
    const dialogRef = this.dialog.open(TicketsTicketPreviewDialogComponent, {
      data: {
        htmlContent: new FakeDollarVarsPipe().transform(this.ticket.TicketHtml)
      }
    });
  }

  public previewZplTicket() {
    let result = null;
    if ((new RegExp('\\^XA')).test(this.ticket.TicketText)) {
      result = '<img src="http://api.labelary.com/v1/printers/8dpmm/labels/3x3/0/' + new FakeDollarVarsPipe().transform(this.ticket.TicketText) + '" style="width:100%;height: auto;">';
    } else {
      result = '<p style="text-align: center;">Zpl not valid</p>';
    }
    const dialogRef = this.dialog.open(TicketsTicketPreviewDialogComponent, {
      data: {
        htmlContent: result
      }
    });
  }

  public getTicketCentersString() {
    if (this.ticket && this.ticket.Centers && (this.ticket.Centers.length > 0)) {
      return this.ticket.Centers.map(c => c.CenterName).join(', ');
    }
    return '';
  }

  ngOnDestroy() {
    if (this.updateTicketStatusSubscription) { this.updateTicketStatusSubscription.unsubscribe(); }
    if (this.deleteTicketSubscription) { this.deleteTicketSubscription.unsubscribe(); }
    if (this.previewZplTicketSubscription) { this.previewZplTicketSubscription.unsubscribe(); }
  }
}


